import { InputTextType,SimpleInputProps} from "./input.type";
import {Check, TriangleAlert, CircleX} from "lucide-react";
import { cn } from '@/lib/utils';
import React, {  useRef } from 'react';

const InputText = ({
    label,
    id,
    type,
    value,
    name,
    success = false,
    error = false,
    required = false,
    ref=null,
    pattern,
    ...rest
}: InputTextType) => {
// Label class
    const mainClassLabelSpanWithValue = `top-1 origin-left scale-75 justify-start`
    const mainClassLabelSpanFocused = `peer-focus:top-1 peer-focus:origin-left peer-focus:scale-75 peer-focus:justify-start 
    peer-autofilled:top-1 peer-autofilled:origin-left peer-autofilled:scale-75 peer-autofilled:justify-start`
    const mainClassLabelSpan = `transition absolute top-0 left-4 text-black text-[16px] italic font-normal flex flex-col justify-center h-full`

    // Input class
    const mainClassNameInput = `peer text-black border focus:border-black w-full outline-0 p-4 pb-2`

    // Error
    const errorClassInput = 'border-red focus:border-red'
    const errorClassLabel = 'text-red'

    // Success
    const successClassInput = 'border-green focus:border-green'
    const successClassLabel = 'text-green'

    // Additional Props
    const additionalProps: { [key: string]: string } = {};

    // Telephone
    if (type === 'tel') {
        const defaultPattern = '^[1-9]\d{1,14}$'

        additionalProps.pattern = pattern || defaultPattern
    }

    // Mail
    if (type === 'email') {
        const defaultPattern = '^.+@.+\..+$'

        additionalProps.pattern = pattern || defaultPattern
    }



    
    return (
        <div className={"relative h-[72px] w-full flex"}>
            <input
                type={type}
                id={id}
                name={name}
                value={value}
                required={required}
                ref={ref || null}  // Utilise ref uniquement s'il est défini

                className={
                    cn(mainClassNameInput,
                        error && errorClassInput,
                        success && successClassInput,

                        // Le laisser en dernier car il overide le reste
                        rest.className,
                        
                    )}
                {...additionalProps}
                {...rest}
            />
            <label
                htmlFor={id}
                className={
                    cn(`${mainClassLabelSpan}`,
                        value ? mainClassLabelSpanWithValue : mainClassLabelSpanFocused,
                        error && errorClassLabel,
                        success && successClassLabel,
                    )}
            >{label}{required && ' *'}</label>

            {error && (
                <div className={"bg-error-medium-high-light flex items-center justify-center text-white p-4"}>
                    <TriangleAlert/>
                </div>
            )}

            {success && (
                <div className={"bg-green flex items-center justify-center text-white p-4"}>
                    <Check/>
                </div>
            )}
        </div>
    )

};

export default InputText;

  
  export const SimpleInput = ({ id, value, placeholder, onChangeHandler, ...rest }: SimpleInputProps) => {
    const mainClassNameInput =  "border p-2 rounded items-center justify-center";
    const buttonRef = useRef<HTMLInputElement>(null);

    
    const changeHandler = (value: string) => {
        onChangeHandler(value);
    }
    
    return (
        <div className="relative">
                <input
                    type="text"
                    ref={buttonRef}

                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => changeHandler(e.target.value)}
                    {...rest}
                    className={ cn(mainClassNameInput,
                            
                            rest.className,
                            
                        )}
                />
            {value && (
                    <button
                    type="button"
                    className="absolute right-2 top-1/2 mt-1  transform -translate-y-1/2 text-gray-500"
                    onClick={() => changeHandler('')}
                    >
                    <CircleX/>
                    </button>
      )}
      </div>
    );
  };
  